import SparkMD5 from "spark-md5";
// import axios from 'axios';

export const md5Mixin = {
  inject: ["baseUrl", "imgBaseUrl", "uploadRequest"],
  data() {
    return {
      options: {
        target: this.baseUrl + "/api/oas-server/file/ossPartUpload", //"/api/file-server/file/partUpload",
        testChunks: false, //不校验
        forceChunkSize: true,
        chunkSize: 1024 * 1024 * 7, //20 * 1024 * 1000,
        headers: {
          Authorization: `${sessionStorage.getItem(
            "token_type"
          )} ${sessionStorage.getItem("token")}`,
        },
        query: {
          // timestamp: new Date().getTime(),
          uploadId: null, //文件唯一表示（上传准备接口返回）
          bucketName: "", //桶名（上传准备接口返回）
          // chunkNumber: '',//当前文件序号
          // file: '',//文件,
          objectKey: "", //附件key（上传准备接口返回）
          tagId: "", //缓存标识（上传准备接口返回）
          // totalChunks: '',//总片数
        },
        processResponse: function (response, cb, file) {
          try {
            const res = JSON.parse(response);
            if (res.code !== 1000) {
              cb("error", response);
            } else {
              cb(null, response);
            }
          } catch (err) {
            cb("error", response);
          }
        },
        // checkChunkUploadedByResponse: function(chunk, message) {
        // 	const response = JSON.parse(message)
        // 	console.log(response, chunk.offset)
        // 	response.uploaded = [1, 2]
        // 	return (response.uploaded || []).indexOf(chunk.offset + 1) >= 0
        // }
      },
      uploader: null,
      uploadId: null,
    };
  },
  mounted() {
    // 获取uploader对象
    this.$nextTick(() => {
      this.uploader = this.$refs.uploader.uploader;
    });
  },
  methods: {
    computeMD5(file) {
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = this.options.chunkSize; //20 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();
      file.pause();

      loadNext();
      fileReader.onload = (e) => {
        spark.append(e.target.result);
        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();
          this.$nextTick(() => {
            console.log(
              "校验MD5 " + ((currentChunk / chunks) * 100).toFixed(0) + "%"
            );
          });
        } else {
          let md5 = spark.end();
          this.computeMD5Success(md5, file);
          console.log(
            `MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${
              file.size
            } 用时：${new Date().getTime() - time} ms`
          );
        }
      };
      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },
    computeMD5Success(md5, file) {
      // axios({
      //     method: 'post',
      //     url: `${this.baseUrl}/api/file-server/file/initiateUpload`,
      //     params: {
      //         filename: file.name
      //     },
      //     headers: {
      //         'cache-contral': 'no-cache',
      //         'Pragma': 'no-cache',
      //         Authorization: `${sessionStorage.getItem('token_type')} ${sessionStorage.getItem('token')}`
      //     }
      // }).then(res => {
      //     this.$set(this.options.query, 'uploadId', res.data.data.uploadId)
      //     this.uplaodId = res.data.uploadId;
      //     file.resume(); //开始上传
      // })
      this.uploadRequest.initiateUpload({ fileName: file.name }).then((res) => {
        this.$set(this.options.query, "uploadId", res.data.uploadId);
        this.$set(this.options.query, "bucketName", res.data.bucketName);
        this.$set(this.options.query, "objectKey", res.data.objectKey);
        this.$set(this.options.query, "tagId", res.data.tagId);
        this.uplaodId = res.data.uploadId;

        file.resume(); //开始上传
      });
    },
    // 上传之前对文件进行校验
    beforeUpload(item, file) {
      let length = this.list.length + this.uploader.fileList.length;
      const limit = item.limit || 1;
      if (length > limit) {
        this.$message({
          message: `上传文件不能超过${limit}个！`,
          type: "warning",
        });
        return false;
      }
      //验证大小,格式
      //fileType是字符串
      item.fileType =
        item.fileType ||
        "doc,docx,xls,xlsx,pdf,ppt,pptx,txt,jpg,jpeg,jpe,png,rar,zip,mp4";
      let maxFileSize = 500;
      item.fileSize = item.fileSize || maxFileSize;
      var testmsg = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      let type = item.fileType.split(",");
      const fileSize = file.size / 1024 / 1024;
      const isLt2M = fileSize < item.fileSize;
      if (type.indexOf(testmsg) == -1 && item.fileType !== "*") {
        this.$message({
          message: `上传文件只能是${item.fileType}格式!`,
          type: "warning",
        });
        return false;
      } else if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过 ${item.fileSize}MB!`,
          type: "warning",
        });
        return false;
      }
      return true;
    },
    //上传成功的事件
    async fileSuccess(rootFile, file, message, chunk) {
      const response = JSON.parse(message);
      console.log(response);
      var r = {
        code: response.code,
        data: {
          name: response.data.fileName,
          id: response.data.fileUrl,
          ...response.data,
        },
      };
      let flag = false;
      if (this.item.target === "editor") {
        // 如果上传请求的来源是富文本编辑器，就不进行后续判断了，直接将图片返回
        this.$emit("uploadImgSuccess", r.data);
        this.uploader.removeFile(file);
        return false;
      }
      if (
        this.item.limit == 0 &&
        this.item.fileList &&
        this.item.fileList.length
      ) {
        this.list = [r.data];
      } else if (this.list) {
        // 过滤重名的文件
        this.list = this.list.filter((val) => {
          if (val.name == r.data.name) {
            flag = true;
          }
          return val.name != r.data.name;
        });
        this.list.push(r.data);
      } else {
        this.list.push(r.data);
      }
      flag
        ? this.$message.warning("文件名重复,已自动覆盖同名文件!")
        : this.$message.success("上传成功!");
      this.fileListChange();
      this.uploader.removeFile(file);
      return;
      this.uploadRequest
        .uploadMerge({ uploadId: response.data.uploadId })
        .then((response) => {
          var r = {
            code: response.code,
            data: {
              name: response.data.originalFilename,
              id: response.data.fileUrl,
              ...response.data,
            },
          };
          if (r.code === 1000 && r.data) {
            let flag = false;
            if (this.item.target === "editor") {
              // 如果上传请求的来源是富文本编辑器，就不进行后续判断了，直接将图片返回
              this.$emit("uploadImgSuccess", r.data);
              this.uploader.removeFile(file);
              return false;
            }
            if (
              this.item.limit == 0 &&
              this.item.fileList &&
              this.item.fileList.length
            ) {
              this.list = [r.data];
            } else if (this.list) {
              // 过滤重名的文件
              this.list = this.list.filter((val) => {
                if (val.name == r.data.name) {
                  flag = true;
                }
                return val.name != r.data.name;
              });
              this.list.push(r.data);
            } else {
              this.list.push(r.data);
            }
            flag
              ? this.$message.warning("文件名重复,已自动覆盖同名文件!")
              : this.$message.success("上传成功!");
            this.fileListChange();
            this.uploader.removeFile(file);
          }
        });
    },
    // 选择文件事件
    onFileAdded(file) {
      file.pause();
      const fileSize = file.size / 1024 / 1024;
      if (this.item.fileSize && fileSize > this.item.fileSize) {
        this.$message({
          message: `上传文件大小不能超过 ${this.item.fileSize}MB!`,
          type: "warning",
        });
        file.cancel();
      } else {
        this.$set(this.options.query, "timestamp", new Date().getTime());
        let flag = this.beforeUpload(this.item, file);
        if (flag) {
          this.computeMD5(file);
        } else {
          file.ignored = true;
        }
        this.$emit("startUpload", flag, file);
      }
      //修改当前分片上传时间戳
    },
    onFileProgress(rootFile, file, chunk) {},
    // 移除上传列表中的文件
    onFileRemove(file) {
      this.fileListLength = this.uploader.fileList.length;
      this.fileListChange();
    },
    // 上传失败
    onFileError(rootFile, file, message, chunk) {
      this.$emit("onFileError", [rootFile, file, message, chunk]);
    },
    // 移除已存在的文件
    remove(item) {
      this.list = this.list.filter((res) => {
        return res.id != item.id;
      });
      this.fileListChange();
    },
    // 文件列表发生改变时
    fileListChange() {
      this.$emit("uploadSuccess", this.list);
    },
    mobanclick(item) {
      this.$utils.exportFile(
        `${this.baseUrl}/csportalsite/yuhua/projectapply/exportTemple`
      );
    },
    // 预览
    seeclick(item, e = {}) {
      let type = "";
      if (item.fileName) {
        type = item.fileName.split(".").pop();
      } else {
        type = item.name.split(".").pop();
      }
      if (["zip", "rar"].includes(type)) {
        this.$utils.exportFile(
          `${this.baseUrl}/csportalsite/api/file/download?id=${item.id}`
        );
      } else {
        if (e.asyncView) {
          this.$utils.getFileView.call(this, item.id);
        } else {
          window.open(`${this.imgBaseUrl}${item.id}`);
        }
      }
    },
    // 根据文件格式渲染图标
    fileImg(item) {
      return this.fileTypeImg(this.getFileType(item.name));
    },
    pause() {
      this.$emit("pause");
    },
    resume() {
      this.$emit("resume");
    },
    startUpload() {
      this.$emit("startUpload");
    },
    fileTypeImg(type) {
      const TYPE = type.toLowerCase();
      const arr = fileType;
      let flag = true;
      for (const item of arr) {
        flag = item.status.some((res) => res == TYPE);
        if (flag) {
          return item.img;
        }
      }

      if (!flag) {
        return arr[arr.length - 1].img;
      }
    },
    getFileType(filePath) {
      return filePath.substr(filePath.lastIndexOf(".") + 1);
    },
  },
};



// WEBPACK FOOTER //
// ./packages/SrBigUpload/common/mixins.js